import type { PersonVersion } from '@festina/legalentity-general-types/legalentity'
import { createRequiredAndOptionalContext } from '@festina-life/ui/libs'

import type { VersionContext } from '../../context/VersionProvider'

const [usePersonVersionContext, useOptionalPersonVersionContext, provider] =
  createRequiredAndOptionalContext<VersionContext<PersonVersion>>('LegalEntity')

export { provider, useOptionalPersonVersionContext, usePersonVersionContext }
